// Uclean-Admin-Dashboard/src/mocks/promo/_shared/pagination.js
// Standard Laravel-paginate wrapper from docs/admin-handover.md §4.1.

export function paginate(rows, { page = 1, perPage = 20 } = {}) {
  const pageNum = Number(page) || 1;
  const per = Number(perPage) || 20;
  const total = rows.length;
  const lastPage = Math.max(1, Math.ceil(total / per));
  const start = (pageNum - 1) * per;
  const slice = rows.slice(start, start + per);
  const empty = slice.length === 0;
  const from = empty ? null : start + 1;
  const to = empty ? null : start + slice.length;
  return {
    data: slice,
    current_page: pageNum,
    last_page: lastPage,
    per_page: per,
    total,
    from,
    to,
  };
}
